// Override Settings
var boostPFSInstantSearchConfig = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    }
};

(function() {
    BoostPFS.inject(this);

    // Customize style of Suggestion box
    SearchInput.prototype.customizeInstantSearch = function() {};

    SearchInput.prototype.afterBindEvents = function() {
        // Fix cannot close search suggestion when clicking overlay 
        document.addEventListener('click', function(e) {
            if (this.searchAutoComplete && this.searchAutoComplete.isOpen && e && e.target) {
                var $clickedElement = jQ(e.target);
                var isClickSuggestion = $clickedElement.closest('.' + Class.searchSuggestionWrapper).length > 0;
                if (isClickSuggestion) {
                    this.searchAutoComplete.$element.hide();
                    this.searchAutoComplete.searchInput.onCloseAutocomplete();
                    this.searchAutoComplete.isOpen = false;
                }
            }
        }.bind(this), true);
    }

    // START BOOST 216850 
    InstantSearchApi.beforeCall = function(searchTerm) {
        // START only show some products to lloged in customers
        if (Globals?.instantSearchQueryParams?.h_options) {
            delete(Globals.instantSearchQueryParams.h_options)
        }
        if (!Globals.instantSearchQueryParams.h_options) Globals.instantSearchQueryParams.h_options = []
        if (!boostPFSConfig.customer.isLogged) {
            Globals.instantSearchQueryParams.h_options.push('non-members');
        }

        // START Remove quotes & dashes from searching
        // Globals.instantSearchQueryParams.q = Utils.encodeURIParamValue(unescape(searchTerm || '').replace(/&#x27;/g, '').replace(/&#x26;/g, '').replace(/&#x2A;/gi, '').replace(/-/g, ' '));
        // if (!Globals.instantSearchQueryParams.q) Globals.instantSearchQueryParams.q = searchTerm // avoid breaking the search
    };

    SearchInput.prototype._bindAutoCompleteSource = function(request, response) {
		window.suggestionCallback = response;
		Globals.currentTerm = Utils.stripHtml(request.term);
		var term = (request.term).trim().replace(/\s+/g, ' ');
		if (term != '') {
			var $instantSearchResult = this.searchAutoComplete.$element;
			this.instantSearchResult.setData($instantSearchResult, null, true);
			this.instantSearchResult.refresh();
			if (Globals.suggestionCache.hasOwnProperty(term)) {
				window.suggestionCallback(Globals.suggestionCache[term]);
				return;
			}
			term = encodeURIComponent(term);
			InstantSearchApi.getSuggestionData(term, 0, 'suggest');
		}
	};

	/**
	 * Bind autocomplete response
	 * @param {Event} event The ui-autocomplete event
	 * @param {Object} autocompleteUi
	 * @param {Array} autocompleteUi.content List result data
	 */
	SearchInput.prototype._bindAutoCompleteResponse = function(event, autocompleteUi) {
		// Prepare data
		var result = autocompleteUi.content;
		var searchTerm = Utils.getValueInObjectArray('query', result);
		var eventType = Utils.getValueInObjectArray('event_type', result);
		var suggestQuery = Utils.getValueInObjectArray('suggest_query', result);
		var localCache = Utils.getValueInObjectArray('local_cache', result);
		var redirect = Utils.getValueInObjectArray('redirect', result);
		// Cache
		if (Object.keys(Globals.suggestionCache).length == 25) Globals.suggestionCache = {};
		if (!(Globals.suggestionCache.hasOwnProperty(searchTerm)) && eventType != 'suggest_dym') {
			Globals.suggestionCache[searchTerm] = result;
		}
		// Send another request to get the product list of suggest_query
		if (suggestQuery != '' && eventType == 'suggest' && !localCache) {
			InstantSearchApi.getSuggestionData(suggestQuery, 0, 'suggest_dym', searchTerm);
		}
		// Check for search redirect after receiving the API response
		InstantSearchResultRedirect.checkForSearchRedirect(this.$element);
	};

    // var searchSubmit = SearchInput.prototype._onSubmit;
    // SearchInput.prototype._onSubmit = function(event, redirect) {
    //   searchSubmit.call(this, event, redirect);

    //   var term = unescape(Globals.currentTerm || '').replace(/&#x27;/g, '').replace(/&#x26;/g, '').replace(/&#x2A;/gi, '').replace(/-/g, ' ');
    //   var isApiReturnedResult = Globals.suggestionCache.hasOwnProperty(term);

    //   var redirectUrl = InstantSearchResultRedirect.getSearchRedirectUrl();

    //   if (isApiReturnedResult) {
    //     if (redirectUrl && !Utils.isBadUrl(redirectUrl)) {
    //       Utils.setWindowLocation(redirectUrl);
    //     } else {
    //       this.isChangePage = true;
    //       this.$searchForm[0].submit();
    //     }
    //   } 
    // }
    // END BOOST 216850 
    if(boostPFSConfig.customer.isLogged){
      jQ('body').removeClass('unlogged').addClass('logged');
    }else{
      jQ('body').removeClass('logged').addClass('unlogged');
    }
})();